module.exports = __webpack_public_path__ + "media/images/signup-and-read-kv-4th@3x-c63bc5059bf7f96b422af776b244a317.png";